var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImguploadicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5002V21.5002M12.5 12.5002L10 14.5002M12.5 12.5002L15 14.5002M5.53402 9.61719C4.58823 9.85518 3.7619 10.4303 3.21028 11.2346C2.65865 12.0389 2.4197 13.0169 2.53833 13.985C2.65695 14.953 3.12499 15.8444 3.85449 16.4917C4.58399 17.139 5.52475 17.4976 6.50002 17.5002H7.50002",
    stroke: "#191D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.33 7.63772C15.9882 6.28429 15.1446 5.11146 13.9702 4.35698C12.7957 3.60249 11.3783 3.32281 10.0053 3.57462C8.63228 3.82643 7.40638 4.5909 6.5761 5.71306C5.74582 6.83521 5.3733 8.23109 5.53404 9.61772C5.53404 9.61772 5.68704 10.4997 6.00004 10.9997",
    stroke: "#191D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.5C18.206 17.4995 18.904 17.3495 19.5479 17.0599C20.1917 16.7702 20.767 16.3475 21.2357 15.8195C21.7045 15.2915 22.0561 14.6702 22.2674 13.9965C22.4787 13.3229 22.545 12.6121 22.4618 11.9109C22.3786 11.2098 22.1479 10.5343 21.7848 9.92874C21.4217 9.32321 20.9345 8.80145 20.3552 8.39778C19.776 7.99412 19.1178 7.71772 18.424 7.58676C17.7302 7.4558 17.0166 7.47327 16.33 7.638L15 8",
    stroke: "#191D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImguploadicon);
export default __webpack_public_path__ + "static/media/imguploadicon.17fec943308f94e399a40923a4762157.svg";
export { ForwardRef as ReactComponent };